<!-- Выбирает калькулятор для фонового пересчёта отмеченных заказов -->
<template>
  <BaseModal
    :visible="visible"
    title="Пересчитать ПЛАН"
    size="md"
    elevated-footer
    @close="$emit('close')"
  >
    <base-loader v-if="isLoading" />

    <template v-else>
      <p class="batch-calculation-modal__message">
        Для {{ orderCountLabel }} будет создана новая версия ПЛАНа.
        Ручные значения сохранятся, если выбран тот же калькулятор.
      </p>

      <BaseFormField
        label="Калькулятор"
        required
        :filled="!!selectedPresetId"
        :error="presetError"
        error-message="Выберите калькулятор"
      >
        <base-select
          v-model="selectedPresetId"
          :options="presetOptions"
          :clearable="false"
          :invalid="presetError"
          placeholder="Выберите калькулятор"
          @update:modelValue="presetError = false"
        />
      </BaseFormField>
    </template>

    <template #footer>
      <base-button :disabled="isSubmitting" @click="$emit('close')">
        Отмена
      </base-button>
      <base-primary-button
        :disabled="isLoading || isSubmitting"
        @click="submit"
      >
        {{ isSubmitting ? "Запускаем..." : "Пересчитать" }}
      </base-primary-button>
    </template>
  </BaseModal>
</template>

<script>
import { formatRussianCount } from "@/utils/pluralizationUtils";

export default {
  name: "OrderCalculationBatchModal",

  props: {
    visible: { type: Boolean, default: false },
    orderCount: { type: Number, required: true },
    presets: { type: Array, default: () => [] },
    defaultPresetId: { type: [Number, String], default: null },
    isLoading: { type: Boolean, default: false },
    isSubmitting: { type: Boolean, default: false },
  },

  emits: ["close", "confirm"],

  data() {
    return {
      selectedPresetId: null,
      presetError: false,
    };
  },

  computed: {
    orderCountLabel() {
      return formatRussianCount(this.orderCount, {
        one: "выбранного заказа",
        few: "выбранных заказов",
        many: "выбранных заказов",
      });
    },
    presetOptions() {
      return this.presets.map((preset) => ({
        value: preset.id,
        label: String(preset.id) === String(this.defaultPresetId)
          ? `${preset.name} (по умолчанию)`
          : preset.name,
      }));
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(visible) {
        if (visible) this.resetSelection();
      },
    },
    presets() {
      if (this.visible && !this.selectedPresetId) this.resetSelection();
    },
  },

  methods: {
    resetSelection() {
      this.selectedPresetId = this.defaultPresetId
        || this.presets[0]?.id
        || null;
      this.presetError = false;
    },
    submit() {
      if (!this.selectedPresetId) {
        this.presetError = true;
        return;
      }

      this.$emit("confirm", this.selectedPresetId);
    },
  },
};
</script>

<style scoped>
.batch-calculation-modal__message {
  margin: 0 0 20px;
  color: var(--color-text-secondary, #5b6070);
  line-height: 1.5;
}
</style>
